import { TopicSelector } from 'Shared/topic_selector';
import WorkbenchManager from 'Shared/workbench_manager';

ContentDropdownGroup(document.querySelectorAll('.workbench-topic-variant-dropdown'));

document.querySelectorAll('#generic-save-topic-button').forEach(button => {
   button.addEventListener('click', () => {
      let variantid = button.dataset.variantid ?? null;
      let wikiid = button.dataset.wikiid;

      if (button.classList.contains('checked')) {
         TopicSelector.deselect(button, variantid, wikiid, /* useIndicator */ true);
      } else {
         TopicSelector.select(button, variantid, wikiid, /* useIndicator */ true);
      }
   });
});

document.querySelectorAll('.js-workbench-checkbox').forEach(checkbox => {
   checkbox.addEventListener('click', () => {
      const ADD_TO_WORKBENCH = 'add';
      const REMOVE_FROM_WORKBENCH = 'remove';

      let action = checkbox.checked ? ADD_TO_WORKBENCH : REMOVE_FROM_WORKBENCH;
      let variantid = checkbox.dataset.topicVariantid ?? null;
      let wikiid = checkbox.dataset.wikiid;

      if (action == ADD_TO_WORKBENCH) {
         document.getElementById('topic-generic').checked = !variantid;
         WorkbenchManager.addItem(variantid, wikiid, /* useIndicator */ true);
      } else {
         WorkbenchManager.removeItem(variantid, wikiid, /* useIndicator */ true);
      }

      TopicSelector.updateVariantDropdownState();
   });
});
